var map = {
	"./01_balance.json": "qHKX",
	"./02_order.json": "tdP1",
	"./03_setting.json": "PEUY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Y7Gx";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/cswap/websocket/account \.json$
// module id = Y7Gx
// module chunks = 3